import { track } from './track';

// Google Analytics loads after the first scroll/tap/keypress or 6 seconds, whichever comes first,
// so neither react-ga4 nor gtag's 175 KB script compete with the first paint.
let ga = null;
let started = false;
export const initGA = () => {
  const start = () => {
    if (started) return;
    started = true;
    import('react-ga4').then(({ default: ReactGA }) => {
      ReactGA.initialize('G-LK3VNDBVVC');
      ReactGA.send({ hitType: 'pageview', page: window.location.pathname });
      ga = ReactGA;
    });
  };
  for (const ev of ['scroll', 'pointerdown', 'keydown']) window.addEventListener(ev, start, { once: true, passive: true });
  setTimeout(start, 6000);
};

// Track page views
export const logPageView = () => {
  if (ga) ga.send({ hitType: 'pageview', page: window.location.pathname });
  track('view');
};

// Track custom events
// Also feeds /admin analytics: resume downloads, email/social clicks, contact messages.
export const logEvent = (category, action, label) => {
  if (category === 'Resume') track('resume', label);
  else if (category === 'Social') track('social', label);
  else if (category === 'Project') track('project', label);
  else if (category === 'Contact' && label === 'Email Link') track('email', label);
  else if (category === 'Contact' && action === 'Submit') track('contact', label);
  else if (category === 'Chat') {   // Open | Form | Q: <answered question> | U: <question it couldn't answer>
    track('chat', action === 'Question' ? `Q: ${label}` : action === 'Unanswered' ? `U: ${label}` : action);
  }
  if (ga) ga.event({ category, action, label });
};
